export default __webpack_public_path__ + "static/media/e-merkator-cast-pt.c83c721e.png";